module.exports = __webpack_public_path__ + "img/fotokino7.89a176eb.jpg";